import apiInstance from "@/lib/axios";

export interface SubscribeToNotificationsData {
  webPushSubscription: PushSubscription;
}

export const subscribeToNotifications = async (data: SubscribeToNotificationsData) => {
  const response = await apiInstance.post("/api/notifications/subscribe", data);
  return response;
};

